<template>
  <div class="articlemanagement">
    <Card :bordered="false">
      <Row>
        <Col
          :xs="24"
          :sm="24"
          :md="6"
          :lg="6"
        >
          <Card :bordered="false">
            <div slot="title">
              <Row>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="8"
                  :lg="8"
                >
                  <Divider orientation="left">{{langMap.userList[lang]}}</Divider>
                </Col>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="16"
                  :lg="16"
                >
                  <Form :label-width="80">
                    <div class="des-cardTittle-box">
                      <FormItem
                        :label="langMap.keyword[lang]"
                        class="leftFlex"
                      >
                        <Input
                          v-model.trim="term"
                          :placeholder="langMap.keyword[lang]"
                        />
                      </FormItem>
                      <Button
                        type="info"
                        style="margin-left:20px;"
                        @click="searchUserData"
                      >{{langMap.search[lang]}}</Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </div>

            <Table
              @on-row-click="onRowClick"
              :height="height"
              :loading="userTableLoading"
              border
              :columns="userListCol"
              :data="userList"
            ></Table>
            <!--分页数据-->
            <div
              style="text-align:center;padding-top:10px;"
              v-if="userList.length>0"
            >
              <Page
                :current="userIndex"
                :total="userTotal"
                :page-size="15"
                @on-change="goPageData"
              ></Page>
            </div>
          </Card>
        </Col>
        <Col
          :xs="24"
          :sm="24"
          :md="18"
          :lg="18"
        >
          <Card :bordered="false">
            <div slot="title">
              <Row>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="20"
                  :lg="20"
                >
                  <Divider orientation="left">{{title}}</Divider>
                </Col>
                <Col
                  :xs="24"
                  :sm="24"
                  :md="4"
                  :lg="4"
                >
                  <Form :label-width="80">
                    <div class="des-cardTittle-box">
                      <Button
                        type="info"
                        style="margin-left:20px;"
                        @click="searchData"
                      >{{langMap.search[lang]}}</Button>
                      <Button
                        type="primary"
                        style="margin-left:20px;"
                        @click="modelShow(true, null)"
                      >{{langMap.add[lang]}}</Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </div>
            <Table
              :height="height2"
              :loading="tableLoading"
              border
              :columns="col"
              :data="robotList"
            ></Table>
          </Card>
        </Col>
      </Row>
    </Card>
    <Modal
      v-model="saveModal"
      :title="langMap.robotUserChange[lang]"
      @on-ok="ok"
      @on-cancel="cancel">
      <Checkbox-group v-model="ids">
        <Checkbox :label="item.id" v-for="item in allRobotList" :key="item.id">{{item.name}}</Checkbox>
      </Checkbox-group>
    </Modal>
  </div>
</template>

<script>
  import api from "../../../api/index.js";
  import langMap from '@/utils/language';
  import { mapState } from 'vuex';
  export default {
    components: {},
    data() {
      return {
        langMap:langMap,
        ids:[],
        title:'',
        height: document.documentElement.clientHeight - 335,
        height2: document.documentElement.clientHeight - 300,
       
        robotList: [],
        //表格
        tableLoading: false,
        userTableLoading: false,
        code: "",
        name: "",
        type: "",
        //用户列表
        userList: [],
        userIndex: 1,
        userTotal: 0,
        term:'',
        selectRow:{},
        saveModal: false,
        allRobotList:[],
      };
    },
    computed: {
      ...mapState({
        lang: state => state.app.language
      }),
      col() {
        return [
          {
            title: "#",
            width: 80,
            key: "index",
            render(h, params) {
              return h("span", params.index + 1);
            }
          },
          {
            title: langMap.productId[this.lang],
            width: 120,
            key: "productId"
          },
          {
            title: langMap.serialNumberLabel[this.lang],
            width: 120,
            key: "code" // productId
          },
          {
            title: langMap.name[this.lang],
            width: 120,
            key: "name"
          },
          {
            title: langMap.modelNumber[this.lang],
            width: 125,
            key: "type"
          },
          {
            title: langMap.description[this.lang],
            minWidth: 100,
            key: "description"
          },
          {
            title: langMap.operation[this.lang],
            width: 255,
            align: "center",
            render: (h, params) => {
              //渲染数组
              var renderArray = [];
              /*renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.modelShow(true, params.row);
                      }
                    }
                  },
                  "添加"
                )
              );
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );*/
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmDeleteRobot[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "robot-server/user/robot/delete/?robotId=" + params.row.id + "&userId=" + this.selectRow.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.delete[this.lang]
                )
              );
              return h("div", renderArray);
            }
          }
        ]
      },
      userListCol (){
        return [
          {
            title: langMap.name[this.lang],
            minWidth: 120,
            key: "name",
            render: (h, params) => {
              return h("span", params.row.name ? params.row.name : langMap.noRole[this.lang]);
            }
          },

          {
            title: langMap.phoneNumber[this.lang],
            minWidth: 120,
            key: "phone"
          },

          {
            title: langMap.userRole[this.lang],
            minWidth: 120,
            key: "roleName",
            render: (h, params) => {
              return h(
                "span",
                params.row.roleName ? params.row.roleName : langMap.noRole[this.lang]
              );
            }
          }
        ]
      }
    },
    methods: {
      onRowClick(row){
        this.selectRow = row;
        this.getList();
      },
      searchUserData(){
        this.index = 1;
        this.getUserInfoList();
      },
      //用户信息列表
      getUserInfoList() {
        this.userTableLoading = true;
        api
          .getData(
            "system-server/user/list?index=" +
            this.userIndex +
            "&term=" +
            this.term,
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              this.userTotal = res.data.total;
              this.userList = res.data.rows;
              if(res.data.total > 0){
                this.selectRow = this.userList[0];
                this.getList();
              }
            }
            this.userTableLoading = false;
          });
      },
      //获取列表
      getList() {
        this.title = this.selectRow.name + langMap.robotListForUser[this.lang];
        this.tableLoading = true;
        api
          .getData(
            "robot-server/user/robot/list/"+this.selectRow.id,
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              this.robotList = res.data
            }
            this.tableLoading = false;
          });
      },
      //搜索数据
      searchData() {
        this.getList();
      },
      //分页数据
      goPageData(index) {
        this.userIndex = index;
        this.getUserInfoList();
      },
      modelShow(flag, data) {
        this.ids = [];
        api
          .getData(
            "robot-server/robot/list/all",
            this
          )
          .then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              });
            } else {
              this.allRobotList = res.data || [];
              for(var x =0 ;x<this.robotList.length; x++){
                this.ids.push(this.robotList[x].id);
              }
              this.saveModal = flag;
            }
          });

      },
      ok() {
        let data = {
          userId: this.selectRow.id,
          robotId: this.ids
        }
        api
          .postData("robot-server/user/robot/save", data, this)
          .then(res => {
            this.btnLoading = false;
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.promptFromSystem[this.lang],
                desc: res.msg
              });
            } else {
              this.$Notice.success({
                title: langMap.promptFromSystem[this.lang],
                desc: langMap.operationSuccess[this.lang]
              });
              this.getList();
              this.saveModal = false;
            }
          });
      },
      cancel() {
        //this.$Message.info('Clicked cancel');
        this.saveModal = false;
      }
    },
    created() {
      this.getUserInfoList();
    }
  };
</script>

<style>
</style>
